export const calculateLbm = (weight?: number | null, bodyFatMass?: number | null) => {
  if (!weight || !bodyFatMass) {
    return null;
  }

  return +(weight - bodyFatMass).toFixed(1);
};
